export default {
	title: "Goal",
	dueLabel: "Due",
	lastUpdatedLabel: "Last updated",
	confidenceLabel: "Confidence",
	progressAndPacingLabel: "Progress & Pacing",
	currentLabel: "Current",
	targetLabel: "Target",
};
